// https://developer.mozilla.org/en-US/docs/Web/API/document.com
var docCookies = {
  getItem: function (sKey) {
    if (!sKey) { return null; }
    return decodeURIComponent(document.cookie.replace(new RegExp("(?:(?:^|.*;)\\s*" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=\\s*([^;]*).*$)|^.*$"), "$1")) || null;
  },
  setItem: function (sKey, sValue, vEnd, sPath, sDomain, bSecure) {
    if (!sKey || /^(?:expires|max\-age|path|domain|secure)$/i.test(sKey)) { return false; }
    var sExpires = "";
    if (vEnd) {
      switch (vEnd.constructor) {
        case Number:
          sExpires = vEnd === Infinity ? "; expires=Fri, 31 Dec 9999 23:59:59 GMT" : "; max-age=" + vEnd;
          break;
        case String:
          sExpires = "; expires=" + vEnd;
          break;
        case Date:
          sExpires = "; expires=" + vEnd.toUTCString();
          break;
      }
    }
    document.cookie = encodeURIComponent(sKey) + "=" + encodeURIComponent(sValue) + sExpires + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "") + (bSecure ? "; secure" : "");
    return true;
  },
  removeItem: function (sKey, sPath, sDomain) {
    if (!this.hasItem(sKey)) { return false; }
    document.cookie = encodeURIComponent(sKey) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT" + (sDomain ? "; domain=" + sDomain : "") + (sPath ? "; path=" + sPath : "");
    return true;
  },
  hasItem: function (sKey) {
    if (!sKey) { return false; }
    return (new RegExp("(?:^|;\\s*)" + encodeURIComponent(sKey).replace(/[\-\.\+\*]/g, "\\$&") + "\\s*\\=")).test(document.cookie);
  },
  keys: function () {
    var aKeys = document.cookie.replace(/((?:^|\s*;)[^\=]+)(?=;|$)|^\s*|\s*(?:\=[^;]*)?(?:\1|$)/g, "").split(/\s*(?:\=[^;]*)?;\s*/);
    for (var nLen = aKeys.length, nIdx = 0; nIdx < nLen; nIdx++) { aKeys[nIdx] = decodeURIComponent(aKeys[nIdx]); }
    return aKeys;
  }
};

/* NOTE: This functionality has been moved to the section for additional analytics scripts */
document.addEventListener("DOMContentLoaded", function(event) {
  [].forEach.call(document.querySelectorAll('[href="/"]'), function updateHomeLink(elm){
    elm.setAttribute('href', 'https://rachio.com');
  });

  [].forEach.call(document.querySelectorAll('[href="http://checkout.rachio.com"]'), function updateHomeLink(elm){
    elm.setAttribute('href', 'checkout.rachio.com/cart');
  });
});

//*** Cart Functionality ***//
var variantToSKU = {
     '4264589765': '8ZULW',
     '4264589829': '16ZULW',
     '4264601477': 'RA1412',
     '10580796293': '16ZULW-B',
     '10690708037': '16RACHBX',
     '4628625413': 'SRV-INSTL-D'
  };
  var SKUToVariant = {
     '8ZULW': '4264589765' ,
     '16ZULW': '4264589829',
     'RA1412': '4264601477',
     '16ZULW-B': '10580796293',
     '16RACHBX': '10690708037',
     'SRV-INSTL-D': '4628625413'
  };
function buildSKUArrayFromCartItems(cartItems){
   var variantIDArr = [];
   var variantIdx = 0;
   var variantLen = cartItems.length;
   for(variantIdx; variantIdx < variantLen; variantIdx++){
     var quantIdx = 0;
     var quantLen = Number(cartItems[variantIdx].quantity);
     for(quantIdx; quantIdx < quantLen; quantIdx++){
       variantIDArr.push(variantToSKU[cartItems[variantIdx].variant_id]);
     }
   }
  return variantIDArr;
}
function arraysAreEqual(arr1, arr2){
  console.log(arr1);
  console.log(arr2);
  var idx = 0;
  var len = arr1.length;
  var retVal = true;
  if(arr1.length !== arr2.length){
    retVal = false;
  }
  else{
    for(idx; idx < len; idx++){
      if(arr1[idx] !== arr2[idx]){
        retVal = false;
        break;
      }
    }
  }
  console.log(retVal);
  return retVal;
}
function syncCartCookieToShopifyCart(){
console.log('setting interval');
var currentCartArr = null;
setInterval(
  function(){
  var currentDate = new Date();
  var futureDate = new Date(currentDate.getTime() + (3.5 * 60000));
  //var cookieValue = docCookies.getItem('rachio-cart');
  var variantToSKU = {
     '4264589765': '8ZULW',
     '4264589829': '16ZULW',
     '4264601477': 'RA1412',
     '10580796293': '16ZULW-B',
     '10690708037': '16RACHBX',
     '4628625413': 'SRV-INSTL-D'
  };
  var SKUToVariant = {
     '8ZULW': '4264589765' ,
     '16ZULW': '4264589829',
     'RA1412': '4264601477',
     '16ZULW-B': '10580796293',
     '16RACHBX': '10690708037',
     'SRV-INSTL-D': '4628625413'
  };
  jQuery.getJSON('/cart.js', function(data){
    var variantIDArr = [];
    var variantIdx = 0;
    var variantLen = data.items.length;
    for(variantIdx; variantIdx < variantLen; variantIdx++){
      var quantIdx = 0;
      var quantLen = Number(data.items[variantIdx].quantity);
      for(quantIdx; quantIdx < quantLen; quantIdx++){
        variantIDArr.push(variantToSKU[data.items[variantIdx].variant_id]);
      }
    }
    if(!currentCartArr || !arraysAreEqual(variantIDArr.sort(), currentCartArr.sort())){
      console.log('updating cookie');
      currentCartArr = variantIDArr;
      docCookies.setItem('rachio-cart', JSON.stringify(variantIDArr), futureDate, '/', '.rachio.com');
    }
  });
},
  500
);
}
function syncShopifyCartToCartCookie(){
	// Get existing Shopify Cart
  	jQuery.getJSON('/cart.js', function(data){
    	var currentCartFromCookie = (JSON.parse(docCookies.getItem('rachio-cart')) || []).sort();
    	var currentCartFromCartJS = buildSKUArrayFromCartItems(data.items).sort();
    	CartJS.clear();
    	currentCartFromCookie.forEach(function(variantStr){
      		CartJS.addItem(Number(SKUToVariant[variantStr]));
    	});
      	arraysAreEqual(currentCartFromCookie, currentCartFromCartJS);
		$(document).on('cart.requestComplete', function(event, cart) {
          	console.log('in cart complete');
      		console.log('comparing');
        	console.log(cart);
      /**/
			if(!arraysAreEqual(currentCartFromCookie, currentCartFromCartJS)){
      			document.location.reload();
      			return;
    		}
    		else{
      			if(currentCartFromCookie.length > 0 && document.querySelector('.cart-empty')){
        			document.location.reload();
      			}
      			else{
        			syncCartCookieToShopifyCart()
      			}
    		}
            /**/
    	});
  	});
}
function clearCartCookieOnCartSubmit(minutes){
  var cookieCleared = false;
  document.querySelector('form#cartform').addEventListener('submit', function(evt){
    var currentDate = new Date();
    var futureDate = new Date(currentDate.getTime() + (minutes || 0)*60000);
    var cookieValue = docCookies.getItem('rachio-cart');
    if(!cookieCleared){
      evt.preventDefault();
      docCookies.setItem('rachio-cart', cookieValue, futureDate, '/', '.rachio.com');
      cookieCleared = true;
      this.submit();
      return false;
    }
  });
}
/**/
$(document).ready(function(event) {
    var currentDate = new Date();
    var futureDate = new Date(currentDate.getTime() + (3.5 * 60000));
  	var cookieValue = docCookies.getItem('rachio-cart');
    docCookies.setItem('rachio-cart', cookieValue, futureDate, '/', '.rachio.com');
  /**/
  	//console.log(document.referrer);
    if(document.referrer === 'http://rachio.com/store'){
    	syncShopifyCartToCartCookie();
    }
    else{
      syncCartCookieToShopifyCart();
    }
    /**/
});
/**/